const fontTheme = {
    fonts: {
      main: `'Montserrat', sans-serif`,

    },
    
  };
  
  export default fontTheme;